import { Users, Heart, Mountain, GraduationCap } from 'lucide-react';
import { Reveal } from '@/components/motion/Reveal';

const useCases = [
  {
    icon: Users,
    title: 'Youth summer camps',
    description: 'Feed hundreds of campers with automated menu planning and Sysco ordering.',
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=70',
  },
  {
    icon: Heart,
    title: 'Faith-based retreats',
    description: 'Coordinate volunteers and eliminate food waste across weekend retreats.',
    image: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?auto=format&fit=crop&w=600&q=70',
  },
  {
    icon: Mountain,
    title: 'Outdoor adventure programs',
    description: 'Manage expedition meals with limited storage and transport logistics.',
    image: 'https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&w=600&q=70',
  },
  {
    icon: GraduationCap,
    title: 'School & nonprofit camps',
    description: 'Create balanced menus aligned with nutrition guidelines and budgets.',
    image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?auto=format&fit=crop&w=600&q=70',
  },
];

export const UseCases = () => {
  return (
    <section id="use-cases" className="bg-ivory py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <span className="eyebrow">Who it's for</span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display text-display-md text-midnight-green mt-5 text-balance">
              Built for camp kitchens of every size.
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-5 max-w-prose font-inter text-base text-slate/70 text-pretty">
              From youth camps to retreat centers, CampChef Pro fits the shape of how camps actually work.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-14">
          {useCases.map((uc, i) => {
            const Icon = uc.icon;
            return (
              <Reveal key={uc.title} delay={i * 90}>
                <article className="group">
                  <div className="relative aspect-[5/3] overflow-hidden rounded-md bg-foreground/5">
                    <img
                      src={uc.image}
                      srcSet={`${uc.image} 600w, ${uc.image.replace('w=600', 'w=1040')} 1040w`}
                      sizes="(min-width: 768px) 520px, 100vw"
                      alt={`${uc.title} — ${uc.description}`}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-midnight-green/40 to-transparent" />
                  </div>
                  <div className="mt-5 flex items-start gap-4">
                    <Icon className="h-5 w-5 text-copper mt-1 shrink-0" strokeWidth={1.6} />
                    <div>
                      <h3 className="font-display text-xl text-midnight-green">{uc.title}</h3>
                      <p className="mt-2 font-inter text-[15px] text-slate/75 leading-relaxed">
                        {uc.description}
                      </p>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
